import gql from 'graphql-tag'
export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
}

/** List of appointment services offered by the pharmacy. */
export type AppointmentServices = {
  __typename?: 'AppointmentServices'
  /** Does the pharmacy offer diagnostics */
  allowsDiagnostics: Maybe<Scalars['Boolean']['output']>
  /** Is the display of the allowed services allowed to be displayed to the customer? */
  allowsDisplayToCustomers: Maybe<Scalars['Boolean']['output']>
  /** Does the pharmacy offer laboratory tests */
  allowsLaboratoryTests: Maybe<Scalars['Boolean']['output']>
  /** Does the pharmacy offer medical aid */
  allowsMedicalAid: Maybe<Scalars['Boolean']['output']>
  /** Does the pharmacy offer own services / own PDLs? */
  allowsOwnPdl: Maybe<Scalars['Boolean']['output']>
  /** Does the pharmacy offer PDLs? */
  allowsPdl: Maybe<Scalars['Boolean']['output']>
  /** Is vaccination offered in the pharmacy? */
  allowsVaccination: Maybe<Scalars['Boolean']['output']>
}

/** Pre-computed slot availability for an appointment service type at a pharmacy. */
export type AvailableSlot = {
  __typename?: 'AvailableSlot'
  /** Number of free slots within the lookahead window. */
  availableCount: Maybe<Scalars['Int']['output']>
  /** Lookahead window in hours used to compute the availability. */
  lookaheadHours: Maybe<Scalars['Int']['output']>
  /** Earliest free slot start time within the lookahead window, or null if no slots are available. */
  nextAvailableAt: Maybe<Scalars['String']['output']>
  /** Appointment service type ID this entry belongs to. */
  serviceTypeId: Maybe<Scalars['Int']['output']>
  /** Appointment service type name this entry belongs to. */
  serviceTypeName: Maybe<Scalars['String']['output']>
}

/** The channel, or multiple, on which pharmacy is advertised. <br>Currently there are 7 channels:<br> 1 - IhreApotheken Plattform (web);<br> 2 - IhreApotheken (mobile app);<br> 3 - ClickDoc (web);<br> 4 - ClickDoc (mobile app);<br> 5 - ADAC (mobile app);<br> 6 - Industry Widgets (JS widgets);<br> 7 - Apofinder Widgets (JS widgets). */
export type Channel = {
  __typename?: 'Channel'
  /** The identifier of a channel. */
  id: Maybe<Scalars['Int']['output']>
  /** This is the new way to check if pharmacy is active. If pharmacy has this flag set to `true`, than it's active in IA system. */
  linkToProfile: Maybe<Scalars['Boolean']['output']>
  /** The channel name. */
  name: Maybe<Scalars['String']['output']>
  /** The channel type. */
  type: Maybe<Scalars['String']['output']>
}

/** The channel on which pharmacy is advertised. Could be more than 1. <br>Currently there are 7 channels:<br> 1 - IhreApotheken Plattform (web);<br> 2 - IhreApotheken (mobile app);<br> 3 - ClickDoc (web);<br> 4 - ClickDoc (mobile app);<br> 5 - ADAC (mobile app);<br> 6 - Industry Widgets (JS widgets);<br> 7 - Apofinder Widgets (JS widgets). */
export type ChannelInput = {
  /** The ID of a channel */
  id: Scalars['Int']['input']
  /** Does pharmacy has profile activated on this channel. If `null` is sent all (active and non-active) will be shown. */
  linkToProfile: InputMaybe<Scalars['Boolean']['input']>
}

/** Classification describes which services pharmacy has. Also know as P-cases. */
export enum Classification {
  /** Phytotheken */
  Pcase1 = 'PCASE1',
  /** Für meine Haut & mich-Bonusprogramm */
  Pcase2 = 'PCASE2',
  /** COVID-19 Tests */
  Pcase3 = 'PCASE3',
  /** Online Bezahlung */
  Pcase4 = 'PCASE4',
  /** Weight Watchers Programm */
  Pcase5 = 'PCASE5',
  /** Spucktest */
  Pcase6 = 'PCASE6',
  /** COVID-19 Immunkarte */
  Pcase7 = 'PCASE7',
  /** Dig. Impfnachweis */
  Pcase8 = 'PCASE8',
  /** Advertisements */
  Pcase9 = 'PCASE9',
  /** mylife Aktionen */
  Pcase10 = 'PCASE10',
  /** COVID-19 Impfservice */
  Pcase11 = 'PCASE11',
  /** mea select */
  Pcase12 = 'PCASE12',
  /** mea premium */
  Pcase13 = 'PCASE13',
  /** nebenan.de */
  Pcase14 = 'PCASE14',
  /** COVID-19 Impfservice Plus */
  Pcase15 = 'PCASE15',
  /** eRezept ClickDoc */
  Pcase16 = 'PCASE16',
  /** Express Botendienst */
  Pcase17 = 'PCASE17',
  /** Chat */
  Pcase18 = 'PCASE18',
  /** hi.health */
  Pcase19 = 'PCASE19',
  /** No-Q Service */
  Pcase20 = 'PCASE20',
  /** Website Integration Service */
  Pcase21 = 'PCASE21',
  /** Ind. Glob. Banner Service */
  Pcase22 = 'PCASE22',
  /** Basica */
  Pcase23 = 'PCASE23',
  /** Apobera */
  Pcase24 = 'PCASE24',
  /** TE.AM */
  Pcase25 = 'PCASE25',
  /** Aponola */
  Pcase26 = 'PCASE26',
  /** Apondium */
  Pcase27 = 'PCASE27',
  /** Migasa */
  Pcase28 = 'PCASE28',
  /** Coda */
  Pcase29 = 'PCASE29',
  /** Aschaffenburg-Gruppe */
  Pcase30 = 'PCASE30',
  Pcase31 = 'PCASE31',
  Pcase32 = 'PCASE32',
  Pcase33 = 'PCASE33',
  Pcase34 = 'PCASE34',
  Pcase35 = 'PCASE35',
  Pcase36 = 'PCASE36',
  Pcase37 = 'PCASE37',
  Pcase38 = 'PCASE38',
  Pcase39 = 'PCASE39',
  Pcase40 = 'PCASE40',
  Pcase41 = 'PCASE41',
  Pcase42 = 'PCASE42',
  Pcase43 = 'PCASE43',
  Pcase44 = 'PCASE44',
  Pcase45 = 'PCASE45',
  Pcase46 = 'PCASE46',
  Pcase47 = 'PCASE47',
  Pcase48 = 'PCASE48',
  Pcase49 = 'PCASE49',
  Pcase50 = 'PCASE50',
  Pcase51 = 'PCASE51',
  Pcase52 = 'PCASE52',
  Pcase53 = 'PCASE53',
  Pcase54 = 'PCASE54',
  Pcase55 = 'PCASE55',
  Pcase56 = 'PCASE56',
  Pcase57 = 'PCASE57',
  Pcase58 = 'PCASE58',
  Pcase59 = 'PCASE59',
  Pcase60 = 'PCASE60',
  Pcase61 = 'PCASE61',
  Pcase62 = 'PCASE62',
  Pcase63 = 'PCASE63',
  Pcase64 = 'PCASE64',
  Pcase65 = 'PCASE65',
  Pcase66 = 'PCASE66',
  Pcase67 = 'PCASE67',
  Pcase68 = 'PCASE68',
  Pcase69 = 'PCASE69',
  Pcase70 = 'PCASE70',
  Pcase71 = 'PCASE71',
  Pcase72 = 'PCASE72',
  Pcase73 = 'PCASE73',
  Pcase74 = 'PCASE74',
  Pcase75 = 'PCASE75',
  Pcase76 = 'PCASE76',
  Pcase77 = 'PCASE77',
  Pcase78 = 'PCASE78',
  Pcase79 = 'PCASE79',
  Pcase80 = 'PCASE80',
  Pcase81 = 'PCASE81',
  Pcase82 = 'PCASE82',
  Pcase83 = 'PCASE83',
  Pcase84 = 'PCASE84',
  Pcase85 = 'PCASE85',
  Pcase86 = 'PCASE86',
  Pcase87 = 'PCASE87',
  Pcase88 = 'PCASE88',
  Pcase89 = 'PCASE89',
  Pcase90 = 'PCASE90',
  Pcase91 = 'PCASE91',
  Pcase92 = 'PCASE92',
  Pcase93 = 'PCASE93',
  Pcase94 = 'PCASE94',
  Pcase95 = 'PCASE95',
  Pcase96 = 'PCASE96',
  Pcase97 = 'PCASE97',
  Pcase98 = 'PCASE98',
  Pcase99 = 'PCASE99',
  Pcase100 = 'PCASE100',
  Pcase101 = 'PCASE101',
  Pcase102 = 'PCASE102',
  Pcase103 = 'PCASE103',
  Pcase104 = 'PCASE104',
  Pcase105 = 'PCASE105',
  Pcase106 = 'PCASE106',
  Pcase107 = 'PCASE107',
  Pcase108 = 'PCASE108',
  Pcase109 = 'PCASE109',
  Pcase110 = 'PCASE110',
  Pcase111 = 'PCASE111',
  Pcase112 = 'PCASE112',
  Pcase113 = 'PCASE113',
  Pcase114 = 'PCASE114',
  Pcase115 = 'PCASE115',
  Pcase116 = 'PCASE116',
  Pcase117 = 'PCASE117',
  Pcase118 = 'PCASE118',
  Pcase119 = 'PCASE119',
  Pcase120 = 'PCASE120',
  Pcase121 = 'PCASE121',
  Pcase122 = 'PCASE122',
  Pcase123 = 'PCASE123',
  Pcase124 = 'PCASE124',
  Pcase125 = 'PCASE125',
  Pcase126 = 'PCASE126',
  Pcase127 = 'PCASE127',
  Pcase128 = 'PCASE128',
  Pcase129 = 'PCASE129',
  Pcase130 = 'PCASE130',
  Pcase131 = 'PCASE131',
  Pcase132 = 'PCASE132',
  Pcase133 = 'PCASE133',
  Pcase134 = 'PCASE134',
  Pcase135 = 'PCASE135',
  Pcase136 = 'PCASE136',
  Pcase137 = 'PCASE137',
  Pcase138 = 'PCASE138',
  Pcase139 = 'PCASE139',
  Pcase140 = 'PCASE140',
  Pcase141 = 'PCASE141',
  Pcase142 = 'PCASE142',
  Pcase143 = 'PCASE143',
  Pcase144 = 'PCASE144',
  Pcase145 = 'PCASE145',
  Pcase146 = 'PCASE146',
  Pcase147 = 'PCASE147',
  Pcase148 = 'PCASE148',
  Pcase149 = 'PCASE149',
  Pcase150 = 'PCASE150',
  Pcase151 = 'PCASE151',
  Pcase152 = 'PCASE152',
  Pcase153 = 'PCASE153',
  Pcase154 = 'PCASE154',
  Pcase155 = 'PCASE155',
  Pcase156 = 'PCASE156',
  Pcase157 = 'PCASE157',
  Pcase158 = 'PCASE158',
  Pcase159 = 'PCASE159',
  Pcase160 = 'PCASE160',
  Pcase161 = 'PCASE161',
  Pcase162 = 'PCASE162',
  Pcase163 = 'PCASE163',
  Pcase164 = 'PCASE164',
  Pcase165 = 'PCASE165',
  Pcase166 = 'PCASE166',
  Pcase167 = 'PCASE167',
  Pcase168 = 'PCASE168',
  Pcase169 = 'PCASE169',
  Pcase170 = 'PCASE170',
  Pcase171 = 'PCASE171',
  Pcase172 = 'PCASE172',
  Pcase173 = 'PCASE173',
  Pcase174 = 'PCASE174',
  Pcase175 = 'PCASE175',
  Pcase176 = 'PCASE176',
  Pcase177 = 'PCASE177',
  Pcase178 = 'PCASE178',
  Pcase179 = 'PCASE179',
  Pcase180 = 'PCASE180',
  Pcase181 = 'PCASE181',
  Pcase182 = 'PCASE182',
  Pcase183 = 'PCASE183',
  Pcase184 = 'PCASE184',
  Pcase185 = 'PCASE185',
  Pcase186 = 'PCASE186',
  Pcase187 = 'PCASE187',
  Pcase188 = 'PCASE188',
  Pcase189 = 'PCASE189',
  Pcase190 = 'PCASE190',
  Pcase191 = 'PCASE191',
  Pcase192 = 'PCASE192',
  Pcase193 = 'PCASE193',
  Pcase194 = 'PCASE194',
  Pcase195 = 'PCASE195',
  Pcase196 = 'PCASE196',
  Pcase197 = 'PCASE197',
  Pcase198 = 'PCASE198',
  Pcase199 = 'PCASE199',
  Pcase200 = 'PCASE200',
}

/** Courier shipping delivery service information. */
export type CourierShippingInformation = {
  __typename?: 'CourierShippingInformation'
  /** Is the courier shipping service enabled (pCase 78 and feature toggled on). */
  enabled: Maybe<Scalars['Boolean']['output']>
  /** Pricing information for the courier shipping service. */
  price: Maybe<DeliveryPrice>
  /** Is the courier shipping service enabled for the pharmacy website. */
  websiteEnabled: Maybe<Scalars['Boolean']['output']>
  /** Is the courier shipping service enabled for the white-label app. */
  wlaEnabled: Maybe<Scalars['Boolean']['output']>
}

/** Working hours for that day, morning and afternoon are set then there is a day break */
export type DailyWorkingHours = {
  __typename?: 'DailyWorkingHours'
  /** In the afternoon */
  afternoon: Maybe<WorkingHours>
  /** All day without daily break */
  allDay: Maybe<WorkingHours>
  /** In the morning */
  morning: Maybe<WorkingHours>
}

export type DeliveryLimits = {
  __typename?: 'DeliveryLimits'
  /** A distance from pharmacy where delivery service is available. */
  airDistance: Maybe<Scalars['Float']['output']>
  /** A distance from pharmacy where delivery service is available. */
  streetDistance: Maybe<Scalars['Float']['output']>
  /** List of zip-codes where delivery service is available. */
  zipCodes: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** Object representing delivery service pricing information. */
export type DeliveryPrice = {
  __typename?: 'DeliveryPrice'
  /** How much delivery service costs, in euro-cents. */
  cost: Maybe<Scalars['Int']['output']>
  /** A minimum order value for a delivery service, in euro-cents. */
  deliveryMinimum: Maybe<Scalars['Int']['output']>
  /** A minimum order value for a free delivery service, in euro-cents. */
  freeDeliveryMinimum: Maybe<Scalars['Int']['output']>
}

/** Object representing delivery slot. */
export type DeliveryTimes = {
  __typename?: 'DeliveryTimes'
  /** Date of the time slot. */
  date: Maybe<Scalars['String']['output']>
  /** A day of a delivery slot. */
  day: Maybe<Scalars['String']['output']>
  /** Flag that says if the time slot is available today or not. */
  slotIsToday: Maybe<Scalars['Boolean']['output']>
  /** Start time of a delivery slot. */
  timeFrom: Maybe<Scalars['String']['output']>
  /** End time of a delivery slot. */
  timeTo: Maybe<Scalars['String']['output']>
  /** Formatted value for delivery slot. */
  value: Maybe<Scalars['String']['output']>
}

export type EmergencyHours = {
  __typename?: 'EmergencyHours'
  from: Maybe<Scalars['DateTime']['output']>
  to: Maybe<Scalars['DateTime']['output']>
}

/** Generated message regarding the pharmacy emergency service opening times. It's in german and customized for small, medium and large screens. */
export type EmergencyTimesMessage = {
  __typename?: 'EmergencyTimesMessage'
  /** Generated message regarding the pharmacy opening times customized for large screens. */
  large: Maybe<EmergencyTimesScreenMessage>
  /** Generated message regarding the pharmacy opening times customized for medium screens. */
  medium: Maybe<EmergencyTimesScreenMessage>
  /** Generated message regarding the pharmacy opening times customized for small screens. */
  small: Maybe<EmergencyTimesScreenMessage>
}

/** Generated message regarding the pharmacy emergency service opening times customized for screen size. */
export type EmergencyTimesScreenMessage = {
  __typename?: 'EmergencyTimesScreenMessage'
  /** A short representation of pharmacy emergency service operational status. Possible values are: `opens soon`, `open`, `closed`. */
  label: Maybe<Scalars['String']['output']>
  /** Generated message regarding the pharmacy emergency service opening times. It's in German. */
  text: Maybe<Scalars['String']['output']>
}

export type ExpressDeliveryInformation = {
  __typename?: 'ExpressDeliveryInformation'
  /** Limitation of a delivery service. */
  deliveryLimits: Maybe<DeliveryLimits>
  /** How fast an order can be delivered. */
  deliveryTime: Maybe<Scalars['Int']['output']>
  /** Is the express delivery service enabled. */
  enabled: Maybe<Scalars['Boolean']['output']>
  /** An inventory type. */
  inventoryType: Maybe<Scalars['String']['output']>
  /** Pricing information for delivery service. */
  price: Maybe<DeliveryPrice>
}

/** A representation of geographical coordinates (latitude and longitude) that is used to specify the location of a physical address on the earth's surface. */
export type GeoPoint = {
  __typename?: 'GeoPoint'
  /** The latitude of geo-location coordinates. */
  lat: Maybe<Scalars['Float']['output']>
  /** The longitude of a geo-location coordinates. */
  lon: Maybe<Scalars['Float']['output']>
}

/** Latitude and longitude input as start location for finding closest pharmacies. */
export type LocationInput = {
  /** Range in which pharmacies are searched. Input is in Elasticsearch distance units (https://www.elastic.co/guide/en/elasticsearch/reference/current/api-conventions.html#distance-units). */
  distance: InputMaybe<Scalars['String']['input']>
  /** Latitude of geolocation, default Berlin lat */
  lat: InputMaybe<Scalars['Float']['input']>
  /** Longitude of geolocation, default Berlin lng */
  lon: InputMaybe<Scalars['Float']['input']>
}

/** Medical magazines pharmacy offers. */
export enum Magazine {
  /** Diabetes "Gut Leben mit Diabetes" */
  Diabetes = 'DIABETES',
  /** Kindermagazin Platsch */
  Kindermagazin = 'KINDERMAGAZIN',
  /** my life */
  Mylife = 'MYLIFE',
  /** my life SeniorenMagazin */
  Mylifesenior = 'MYLIFESENIOR',
  /** Rätselheft */
  Ratselheft = 'RATSELHEFT',
}

/** Information about the medical supply store associated with a pharmacy. */
export type MedicalSupplyStoreInfo = {
  __typename?: 'MedicalSupplyStoreInfo'
  /** City of the medical supply store pharmacy. */
  city: Maybe<Scalars['String']['output']>
  /** Distance in meters between the pharmacy and the medical supply store. Only calculated when explicitly requested. Null if store has no coordinates. */
  distance: Maybe<Scalars['Float']['output']>
  /** Location types of the medical supply store pharmacy. */
  locationTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Name of the medical supply store pharmacy. */
  name: Maybe<Scalars['String']['output']>
  /** The pharmacy ID of the medical supply store. */
  pharmacyId: Maybe<Scalars['Int']['output']>
  /** Postal code of the medical supply store pharmacy. */
  postalCode: Maybe<Scalars['String']['output']>
  /** Street of the medical supply store pharmacy. */
  street: Maybe<Scalars['String']['output']>
  /** ID of the medical supplier. */
  supplierId: Maybe<Scalars['Int']['output']>
  /** Name of the medical supplier (e.g., RAHM). */
  supplierName: Maybe<Scalars['String']['output']>
}

/** The result set for a pharmacy from No-Q system needed by IA system. */
export type NoQ = {
  __typename?: 'NoQ'
  /** The quantity of available or unused slots or appointments for a specific service. */
  noQFreeSpots: Maybe<Scalars['Int']['output']>
  /** The number of available slots for a chosen service. Not all slots have available free spots. */
  noQSlots: Maybe<Scalars['Int']['output']>
  /** Pharmacy unique identifying part of a web address at the No-Q system. */
  noQSlug: Maybe<Scalars['String']['output']>
  /** A web address or URL that can be used to make a reservation or booking for a specific service, hosted on a No-Q platform. */
  noQUrl: Maybe<Scalars['String']['output']>
}

/** A pharmacy result set extended with a No-Q result set. */
export type NoQPharmacy = {
  __typename?: 'NoQPharmacy'
  /** Is pharmacy activated in IA system. Obsolete. */
  active: Maybe<Scalars['Boolean']['output']>
  /** IDs of active appointment service type groups offered by the pharmacy */
  activeServiceGroupIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** IDs of active appointment service types offered by the pharmacy */
  activeServiceTypeIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** List of services for which an appointment can be made at the pharmacy */
  appointmentServices: Maybe<AppointmentServices>
  /** Pre-computed slot availability per appointment service type. Empty array if the pharmacy has no active appointment services. */
  availableSlots: Maybe<Array<Maybe<AvailableSlot>>>
  /** Which channels is the pharmacy subscribed to. */
  channels: Maybe<Array<Maybe<Channel>>>
  /** The city where the pharmacy is located. */
  city: Maybe<Scalars['String']['output']>
  /** Services that pharmacy has and offers. */
  classifications: Maybe<Array<Maybe<Classification>>>
  /** Does pharmacy offers regular delivery service. */
  delivery: Maybe<Scalars['Boolean']['output']>
  /** The calculated distance between the pharmacy and a specific geographical point, expressed in the unit of meters. */
  distance: Maybe<Scalars['Float']['output']>
  /** A message that provides information about the emergency service hours of a pharmacy and has been specifically designed to be displayed on different screen sizes and in the German language. */
  emergencyTimesMessages: Maybe<EmergencyTimesMessage>
  /** Does pharmacy offers express delivery service. */
  expressDelivery: Maybe<Scalars['Boolean']['output']>
  /** Unique pharmacy group identifier. */
  groupId: Maybe<Scalars['String']['output']>
  /** Unique pharmacy identifier. */
  id: Maybe<Scalars['String']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it offered or not. (Not depending on opening hours) */
  isEmergencyServiceOffered: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it open now or not. */
  isEmergencyServiceOpen: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is lunch break now or not. */
  isLunchBreakNow: Maybe<Scalars['Boolean']['output']>
  /** Is online payment (PayPal) available in the pharmacy. */
  isOnlinePaymentAvailable: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open now or not. */
  isOpenNow: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open today or not. */
  isOpenToday: Maybe<Scalars['Boolean']['output']>
  /** Indicates if the pharmacy qualifies as a Versorger-Apotheke. True if pharmacy has: (1) appointment booking with at least one service type enabled, OR (2) pcase 62 (laboratory tests/diagnostics), OR (3) medical aid service enabled. */
  isVersorgerPharmacy: Maybe<Scalars['Boolean']['output']>
  /** The geographical coordinates, such as latitude and longitude, that specify the location of the pharmacy on the earth's surface. */
  location: Maybe<GeoPoint>
  /** Location type labels assigned to this pharmacy (e.g., REGULAR-PHARMACY, B2B-BUNDESWEHR). */
  locationTypes: Maybe<Array<Scalars['String']['output']>>
  /** The logo of the pharmacy. */
  logo: Maybe<Scalars['String']['output']>
  /** A list of magazine subscriptions that the pharmacy has. */
  magazines: Maybe<Array<Maybe<Magazine>>>
  /** Medical supplier name (e.g., RAHM). Only set for pharmacies with MEDICAL-SUPPLY-STORE location type. */
  medicalSupplier: Maybe<Scalars['String']['output']>
  /** Information about the medical supply store associated with this pharmacy, if any. */
  medicalSupplyStore: Maybe<MedicalSupplyStoreInfo>
  /** Pharmacy mobile phone number */
  mobilePhone: Maybe<Scalars['String']['output']>
  /** Pharmacy name. */
  name: Maybe<Scalars['String']['output']>
  /** The result set for a pharmacy from No-Q system needed by IA system. */
  noQ: Maybe<NoQ>
  /** A message that provides information about the hours of operation of a pharmacy and has been specifically designed to be displayed on different screen sizes and in the German language. */
  openingTimesMessages: Maybe<OpeningTimesMessage>
  /** Additional pharmacy name. */
  pharmacyAdditionalName: Maybe<Scalars['String']['output']>
  /** Phone number of the pharmacy */
  phone: Maybe<Scalars['String']['output']>
  /** The postal code of the pharmacy. */
  postcode: Maybe<Scalars['String']['output']>
  /** Emergency times */
  rawEmergencyTimes: Maybe<RawEmergencyTimes>
  /** The address region of the pharmacy. */
  region: Maybe<Scalars['String']['output']>
  /** The slug of the pharmacy. */
  slug: Maybe<Scalars['String']['output']>
  /** The federal state of the pharmacy. */
  state: Maybe<Scalars['String']['output']>
  /** The street address of pharmacy. */
  street: Maybe<Scalars['String']['output']>
  /** Whether this is, or not, the test pharmacy. */
  test: Maybe<Scalars['Boolean']['output']>
  /** Pharmacy WebSDK url */
  webSdkUrl: Maybe<Scalars['String']['output']>
  /** Weekly working hours */
  weeklyWorkingHours: Maybe<WeeklyWorkingHours>
  /** Pharmacy WhatsApp mobile phone number */
  whatsAppMobilePhoneNumber: Maybe<Scalars['String']['output']>
  /** A message that has been automatically generated and provides information about the hours of operation or working hours of a location during a week. */
  workingDays: Maybe<Array<Maybe<WorkingDay>>>
}

/** A collection of pharmacies that have been selected based on a specified filter or criterion extended with No-Q result set. */
export type NoQPharmacyList = {
  __typename?: 'NoQPharmacyList'
  /** A number of pages for a given query. */
  pages: Maybe<Scalars['Int']['output']>
  pharmacies: Maybe<Array<Maybe<NoQPharmacy>>>
  /** A number of results for a given query. */
  results: Maybe<Scalars['Int']['output']>
}

/** A Pharmacy with a No-Q resultset */
export type NoQPharmacyWithServices = {
  __typename?: 'NoQPharmacyWithServices'
  /** Is pharmacy activated in IA system. Obsolete. */
  active: Maybe<Scalars['Boolean']['output']>
  /** Which channels is the pharmacy subscribed to. */
  channels: Maybe<Array<Maybe<Channel>>>
  /** The city where the pharmacy is located. */
  city: Maybe<Scalars['String']['output']>
  /** Services that pharmacy has and offers. */
  classifications: Maybe<Array<Maybe<Classification>>>
  /** Does pharmacy offers regular delivery service. */
  delivery: Maybe<Scalars['Boolean']['output']>
  /** Does pharmacy offers express delivery service. */
  expressDelivery: Maybe<Scalars['Boolean']['output']>
  /** Unique pharmacy identifier. */
  id: Maybe<Scalars['String']['output']>
  /** Is online payment (PayPal) available in the pharmacy. */
  isOnlinePaymentAvailable: Maybe<Scalars['Boolean']['output']>
  /** The geographical coordinates, such as latitude and longitude, that specify the location of the pharmacy on the earth's surface. */
  location: Maybe<GeoPoint>
  /** A list of magazine subscriptions that the pharmacy has. */
  magazines: Maybe<Array<Maybe<Magazine>>>
  /** Pharmacy name. */
  name: Maybe<Scalars['String']['output']>
  /** The No-Q result set for a pharmacy. */
  noQ: Maybe<NoQSinglePharmacyDetail>
  /** The postal code of the pharmacy. */
  postcode: Maybe<Scalars['String']['output']>
  /** The address region of the pharmacy. */
  region: Maybe<Scalars['String']['output']>
  /** The street address of pharmacy. */
  street: Maybe<Scalars['String']['output']>
  /** Whether this is, or not, the test pharmacy. */
  test: Maybe<Scalars['Boolean']['output']>
}

/** Information about services available for booking on No-Q system. */
export type NoQService = {
  __typename?: 'NoQService'
  /** The quantity of available or unused slots or appointments for the service. */
  noqServiceFreeSpots: Maybe<Scalars['Int']['output']>
  /** The name of the service. */
  noqServiceName: Maybe<Scalars['String']['output']>
  /** Service unique identifying part of a web address at the No-Q system. */
  noqServiceSlug: Maybe<Scalars['String']['output']>
  /** The URL for booking the service provided by pharmacy hosted by No-Q platform. */
  noqServiceUrl: Maybe<Scalars['String']['output']>
}

/** The result set for a pharmacy from No-Q system needed by IA system. */
export type NoQSinglePharmacyDetail = {
  __typename?: 'NoQSinglePharmacyDetail'
  /** A list of bookable services provided by pharmacy. */
  noQServices: Maybe<Array<Maybe<NoQService>>>
  /** Pharmacy unique identifying part of a web address at the No-Q system. */
  noQSlug: Maybe<Scalars['String']['output']>
}

/** Generated message regarding the pharmacy opening times. It's in german and customized for small, medium and large screens. */
export type OpeningTimesMessage = {
  __typename?: 'OpeningTimesMessage'
  /** Generated message regarding the pharmacy opening times customized for large screens. */
  large: Maybe<OpeningTimesScreenMessage>
  /** Generated message regarding the pharmacy opening times customized for medium screens. */
  medium: Maybe<OpeningTimesScreenMessage>
  /** Generated message regarding the pharmacy opening times customized for small screens. */
  small: Maybe<OpeningTimesScreenMessage>
}

/** Generated message regarding the pharmacy opening times customized for screen size. */
export type OpeningTimesScreenMessage = {
  __typename?: 'OpeningTimesScreenMessage'
  /** A short representation of pharmacy operational status. Possible values are: `opens soon`, `open`, `closed`. */
  label: Maybe<Scalars['String']['output']>
  /** Generated message regarding the pharmacy opening times. It's in German. */
  text: Maybe<Scalars['String']['output']>
}

/** Response object representing pharmacy. */
export type Pharmacy = {
  __typename?: 'Pharmacy'
  /** Is pharmacy activated in IA system. Obsolete. */
  active: Maybe<Scalars['Boolean']['output']>
  /** IDs of active appointment service type groups offered by the pharmacy */
  activeServiceGroupIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** IDs of active appointment service types offered by the pharmacy */
  activeServiceTypeIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** List of services for which an appointment can be made at the pharmacy */
  appointmentServices: Maybe<AppointmentServices>
  /** Pre-computed slot availability per appointment service type. Empty array if the pharmacy has no active appointment services. */
  availableSlots: Maybe<Array<Maybe<AvailableSlot>>>
  /** Which channels is the pharmacy subscribed to. */
  channels: Maybe<Array<Maybe<Channel>>>
  /** The city where the pharmacy is located. */
  city: Maybe<Scalars['String']['output']>
  /** Services that pharmacy has and offers. */
  classifications: Maybe<Array<Maybe<Classification>>>
  /** Does pharmacy offers regular delivery service. */
  delivery: Maybe<Scalars['Boolean']['output']>
  /** The calculated distance between the pharmacy and a specific geographical point, expressed in the unit of meters. */
  distance: Maybe<Scalars['Float']['output']>
  /** A message that provides information about the emergency service hours of a pharmacy and has been specifically designed to be displayed on different screen sizes and in the German language. */
  emergencyTimesMessages: Maybe<EmergencyTimesMessage>
  /** Does pharmacy offers express delivery service. */
  expressDelivery: Maybe<Scalars['Boolean']['output']>
  /** Unique pharmacy group identifier. */
  groupId: Maybe<Scalars['String']['output']>
  /** Unique pharmacy identifier. */
  id: Maybe<Scalars['String']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it offered or not. (Not depending on opening hours) */
  isEmergencyServiceOffered: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it open now or not. */
  isEmergencyServiceOpen: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is lunch break now or not. */
  isLunchBreakNow: Maybe<Scalars['Boolean']['output']>
  /** Is online payment (PayPal) available in the pharmacy. */
  isOnlinePaymentAvailable: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open now or not. */
  isOpenNow: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open today or not. */
  isOpenToday: Maybe<Scalars['Boolean']['output']>
  /** Indicates if the pharmacy qualifies as a Versorger-Apotheke. True if pharmacy has: (1) appointment booking with at least one service type enabled, OR (2) pcase 62 (laboratory tests/diagnostics), OR (3) medical aid service enabled. */
  isVersorgerPharmacy: Maybe<Scalars['Boolean']['output']>
  /** The geographical coordinates, such as latitude and longitude, that specify the location of the pharmacy on the earth's surface. */
  location: Maybe<GeoPoint>
  /** Location type labels assigned to this pharmacy (e.g., REGULAR-PHARMACY, B2B-BUNDESWEHR). */
  locationTypes: Maybe<Array<Scalars['String']['output']>>
  /** The logo of the pharmacy. */
  logo: Maybe<Scalars['String']['output']>
  /** A list of magazine subscriptions that the pharmacy has. */
  magazines: Maybe<Array<Maybe<Magazine>>>
  /** Medical supplier name (e.g., RAHM). Only set for pharmacies with MEDICAL-SUPPLY-STORE location type. */
  medicalSupplier: Maybe<Scalars['String']['output']>
  /** Information about the medical supply store associated with this pharmacy, if any. */
  medicalSupplyStore: Maybe<MedicalSupplyStoreInfo>
  /** Pharmacy mobile phone number */
  mobilePhone: Maybe<Scalars['String']['output']>
  /** Pharmacy name. */
  name: Maybe<Scalars['String']['output']>
  /** A message that provides information about the hours of operation of a pharmacy and has been specifically designed to be displayed on different screen sizes and in the German language. */
  openingTimesMessages: Maybe<OpeningTimesMessage>
  /** Additional pharmacy name. */
  pharmacyAdditionalName: Maybe<Scalars['String']['output']>
  /** Phone number of the pharmacy */
  phone: Maybe<Scalars['String']['output']>
  /** The postal code of the pharmacy. */
  postcode: Maybe<Scalars['String']['output']>
  /** Emergency times */
  rawEmergencyTimes: Maybe<RawEmergencyTimes>
  /** The address region of the pharmacy. */
  region: Maybe<Scalars['String']['output']>
  /** The slug of the pharmacy. */
  slug: Maybe<Scalars['String']['output']>
  /** The federal state of the pharmacy. */
  state: Maybe<Scalars['String']['output']>
  /** The street address of pharmacy. */
  street: Maybe<Scalars['String']['output']>
  /** Whether this is, or not, the test pharmacy. */
  test: Maybe<Scalars['Boolean']['output']>
  /** Pharmacy WebSDK url */
  webSdkUrl: Maybe<Scalars['String']['output']>
  /** Weekly working hours */
  weeklyWorkingHours: Maybe<WeeklyWorkingHours>
  /** Pharmacy WhatsApp mobile phone number */
  whatsAppMobilePhoneNumber: Maybe<Scalars['String']['output']>
  /** A message that has been automatically generated and provides information about the hours of operation or working hours of a location during a week. */
  workingDays: Maybe<Array<Maybe<WorkingDay>>>
}

export type PharmacyAdditionalInformation = {
  __typename?: 'PharmacyAdditionalInformation'
  /** Does the pharmacy allow ApothekenDe live chat (has pCase 46, pCase 75, liveChatEnabledApothekenDe and liveChatIdApothekenDe set) */
  allowsApothekenDeLiveChat: Maybe<Scalars['Boolean']['output']>
  /** Is couponing available in the pharmacy */
  allowsCouponing: Maybe<Scalars['Boolean']['output']>
  /** Does the pharmacy allow live chat (has pCase 75 and live chat enabled) */
  allowsLiveChat: Maybe<Scalars['Boolean']['output']>
  /** Is online payment (PayPal) available in the pharmacy. */
  allowsPayments: Maybe<Scalars['Boolean']['output']>
  /** Unique identifier in ApothekenDe system */
  apodeId: Maybe<Scalars['Int']['output']>
  /** Shows if the pharmacy has My Life magazine active */
  hasMyLife: Maybe<Scalars['Boolean']['output']>
  /** Deprecated. Always returns true. Kept for backwards compatibility. */
  isPlus: Maybe<Scalars['Boolean']['output']>
  /** Is pharmacy used for testing */
  isTestPharmacy: Maybe<Scalars['Boolean']['output']>
  /** Shows if pharmacy has live chat enabled */
  liveChatEnabled: Maybe<Scalars['Boolean']['output']>
  /** Shows if pharmacy has ApothekenDe live chat enabled */
  liveChatEnabledApothekenDe: Maybe<Scalars['Boolean']['output']>
  /** Pharmacy live chat ID */
  liveChatId: Maybe<Scalars['String']['output']>
  /** Pharmacy live chat ID for ApothekenDe */
  liveChatIdApothekenDe: Maybe<Scalars['Int']['output']>
  /** Pharmacy logo URL. */
  logo: Maybe<Scalars['String']['output']>
  /** Shows if the user has to manually add My Life magazine */
  myLifeManual: Maybe<Scalars['Boolean']['output']>
  /** Pharmacy name. */
  name: Maybe<Scalars['String']['output']>
  /** Is online payment (HiHealth) available in the pharmacy. */
  offersHiHealth: Maybe<Scalars['Boolean']['output']>
  /** Is vaccine booking available in the pharmacy. */
  offersVaccineBooking: Maybe<Scalars['Boolean']['output']>
  /** Show WhatsApp on Website toggle */
  showWhatsapp: Maybe<Scalars['Boolean']['output']>
  /** A pharmacy slug */
  slug: Maybe<Scalars['String']['output']>
  /** Pharmacy page on IA web platform */
  url: Maybe<Scalars['String']['output']>
}

/** Working hours day by day. If null day is off. */
export type PharmacyBusinessHours = {
  __typename?: 'PharmacyBusinessHours'
  days: Maybe<Array<Maybe<PharmacyWorkingDays>>>
  /** Shows pharmacy operational status, is lunch break now or not. */
  isLunchBreakNow: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open now or not. */
  isOpenNow: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy operational status, is it open today or not. */
  isOpenToday: Maybe<Scalars['Boolean']['output']>
  status: Maybe<OpeningTimesMessage>
}

export type PharmacyCompanyInformation = {
  __typename?: 'PharmacyCompanyInformation'
  /** Pharmacy legal entity. */
  legalEntity: Maybe<Scalars['String']['output']>
  /** Pharmacy company name. */
  name: Maybe<Scalars['String']['output']>
  /** List of owners. */
  owners: Maybe<Array<Maybe<PharmacyCompanyOwner>>>
}

/** Information about pharmacy company owner. */
export type PharmacyCompanyOwner = {
  __typename?: 'PharmacyCompanyOwner'
  /** Company owner name. */
  name: Maybe<Scalars['String']['output']>
  /** Company owner title. */
  title: Maybe<Scalars['String']['output']>
}

/** Set of information of pharmacy contact. */
export type PharmacyContactInformation = {
  __typename?: 'PharmacyContactInformation'
  /** Pharmacy e-mail address. */
  email: Maybe<Scalars['String']['output']>
  /** Pharmacy telefax number. */
  fax: Maybe<Scalars['String']['output']>
  /** Pharmacy mobile phone number */
  mobilePhone: Maybe<Scalars['String']['output']>
  /** Pharmacy telephone number. */
  phone: Maybe<Scalars['String']['output']>
  /** Pharmacy social network presence. */
  socialLinks: Maybe<SocialLinks>
  /** Pharmacy website address. */
  websiteUrl: Maybe<Scalars['String']['output']>
  /** Pharmacy WhatsApp mobile phone number */
  whatsAppMobilePhoneNumber: Maybe<Scalars['String']['output']>
}

export type PharmacyDeliveryInformation = {
  __typename?: 'PharmacyDeliveryInformation'
  /** Courier shipping delivery service information. */
  courierShipping: Maybe<CourierShippingInformation>
  /** DIMDI register URL the footer logo links to; empty when not shown. */
  dimdiLicenseUrl: Maybe<Scalars['String']['output']>
  express: Maybe<ExpressDeliveryInformation>
  /** Pickup locker delivery service information. */
  pickupLocker: Maybe<PickupLockerInformation>
  /** Whether the DIMDI logo should be shown in the website footer (courier or locker feature active). */
  showDimdiFooterLogo: Maybe<Scalars['Boolean']['output']>
  standard: Maybe<StandardDeliveryInformation>
}

/** Response object representing pharmacy. */
export type PharmacyInDetail = {
  __typename?: 'PharmacyInDetail'
  /** IDs of active appointment service type groups offered by the pharmacy */
  activeServiceGroupIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** IDs of active appointment service types offered by the pharmacy */
  activeServiceTypeIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Additional information about pharmacy. */
  additionalInformation: Maybe<PharmacyAdditionalInformation>
  /** The apotheken.de pharmacy identifier. */
  apoDeId: Maybe<Scalars['Int']['output']>
  /** List of services for which an appointment can be made at the pharmacy */
  appointmentServices: Maybe<AppointmentServices>
  businessHours: Maybe<PharmacyBusinessHours>
  /** Which channels is the pharmacy subscribed to. */
  channels: Maybe<Array<Maybe<Channel>>>
  /** Services that pharmacy has and offers. */
  classifications: Maybe<Array<Maybe<Classification>>>
  company: Maybe<PharmacyCompanyInformation>
  contact: Maybe<PharmacyContactInformation>
  delivery: Maybe<PharmacyDeliveryInformation>
  /** A message that provides information about the emergency service hours of a pharmacy and has been specifically designed to be displayed on different screen sizes and in the German language. */
  emergencyTimesMessages: Maybe<EmergencyTimesMessage>
  /** Unique pharmacy group identifier. */
  groupId: Maybe<Scalars['Int']['output']>
  /** Unique pharmacy identifier. */
  id: Maybe<Scalars['String']['output']>
  /** Unique pharmacy identifier (UUID version). */
  identifier: Maybe<Scalars['String']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it offered or not. (Not depending on opening hours) */
  isEmergencyServiceOffered: Maybe<Scalars['Boolean']['output']>
  /** Shows pharmacy emergency service (notdienst) operational status, is it open now or not. */
  isEmergencyServiceOpen: Maybe<Scalars['Boolean']['output']>
  location: Maybe<PharmacyLocationInformation>
  /** A list of magazine subscriptions that the pharmacy has. */
  magazines: Maybe<Array<Maybe<Magazine>>>
  /** Information about the medical supply store associated with this pharmacy, if any. */
  medicalSupplyStore: Maybe<MedicalSupplyStoreInfo>
  /** Additional pharmacy name. */
  pharmacyAdditionalName: Maybe<Scalars['String']['output']>
  /** The postal code of the pharmacy. */
  postcode: Maybe<Scalars['String']['output']>
  services: Maybe<Array<Maybe<Service>>>
  /** The federal state of the pharmacy. */
  state: Maybe<Scalars['String']['output']>
  /** Pharmacy WebSDK url */
  webSdkUrl: Maybe<Scalars['String']['output']>
}

/** A collection of pharmacies that have been selected based on a specified filter or criterion. */
export type PharmacyList = {
  __typename?: 'PharmacyList'
  /** A number of pages for a given query. */
  pages: Maybe<Scalars['Int']['output']>
  pharmacies: Maybe<Array<Maybe<Pharmacy>>>
  /** A number of results for a given query. */
  results: Maybe<Scalars['Int']['output']>
}

/** Response object representing list of pharmacies. */
export type PharmacyListInDetail = {
  __typename?: 'PharmacyListInDetail'
  pharmacies: Maybe<Array<Maybe<PharmacyInDetail>>>
}

/** Set of information for pharmacy location. */
export type PharmacyLocationInformation = {
  __typename?: 'PharmacyLocationInformation'
  /** The city where the pharmacy is located. */
  city: Maybe<Scalars['String']['output']>
  /** The geographical coordinates, such as latitude and longitude, that specify the location of the pharmacy on the earth's surface. */
  geo: Maybe<GeoPoint>
  /** The postal code of the pharmacy. */
  postcode: Maybe<Scalars['String']['output']>
  /** The address region of the pharmacy. */
  region: Maybe<Scalars['String']['output']>
  /** The street address of pharmacy. */
  street: Maybe<Scalars['String']['output']>
}

/** Information about pharmacy working hors day by day. */
export type PharmacyWorkingDays = {
  __typename?: 'PharmacyWorkingDays'
  /** Afternoon hours */
  afternoon: Maybe<PharmacyWorkingHours>
  /** The name of a day, in German. */
  day: Maybe<Scalars['String']['output']>
  /** Is this day a current day. */
  isToday: Maybe<Scalars['Boolean']['output']>
  /** Morning hours */
  morning: Maybe<PharmacyWorkingHours>
  /** Text describing pharmacy working hours for a day. */
  text: Maybe<Scalars['String']['output']>
}

/** Start and end times for a pharmacy */
export type PharmacyWorkingHours = {
  __typename?: 'PharmacyWorkingHours'
  /** Time of end */
  end: Maybe<Scalars['String']['output']>
  /** Time of start */
  start: Maybe<Scalars['String']['output']>
}

/** Pickup locker delivery service information. */
export type PickupLockerInformation = {
  __typename?: 'PickupLockerInformation'
  /** Is the pickup locker service enabled (pCase 79 and feature toggled on). */
  enabled: Maybe<Scalars['Boolean']['output']>
  /** Is the pickup locker service enabled for the pharmacy website. */
  websiteEnabled: Maybe<Scalars['Boolean']['output']>
  /** Is the pickup locker service enabled for the white-label app. */
  wlaEnabled: Maybe<Scalars['Boolean']['output']>
}

/** Pharmacies search */
export type Query = {
  __typename?: 'Query'
  /** Returns a list of pharmacies ordered by distance from a given coordinates. <br>List can be filtered by exposed filters. */
  getClosestPharmacies: Maybe<PharmacyList>
  /** Returns a list of pharmacies ordered, first by post code and distance within this postcode, and then by distance from a given coordinates. <br>List can be filtered by exposed filters. */
  getClosestPharmaciesBoostPostCode: Maybe<PharmacyList>
  /** Returns a list of pharmacies ordered by distance from a given coordinates that offers given service to be booked in No-Q system. <br>List can be filtered by exposed filters. */
  getClosestPharmaciesForNoQService: Maybe<NoQPharmacyList>
  /** Returns a list of pharmacies ordered by distance from a given coordinates. <br>Only pharmacies that offers products identified by given PZNs will be listed. If PZN isn't recognized, that PZN will be discarded. <br>List can be additionally filtered by exposed filters. */
  getClosestPharmaciesWithPZNs: Maybe<PharmacyList>
  /** Returns a list of pharmacies ordered, first by post code and distance within this postcode, and then by distance from a given coordinates.  <br>Only pharmacies that offers products identified by given PZNs will be listed. If PZN isn't recognized, that PZN will be discarded. <br>List can be additionally filtered by exposed filters. */
  getClosestPharmaciesWithPZNsBoostPostCode: Maybe<PharmacyList>
  /** Returns a list of pharmacies with details. */
  getPharmacyDetailByIdentifierList: Maybe<PharmacyListInDetail>
  /** Returns a list of pharmacies with details. */
  getPharmacyDetailList: Maybe<PharmacyListInDetail>
  /** Returns a single pharmacy result set. */
  getPharmacyDetails: Maybe<PharmacyInDetail>
  /** Returns a single pharmacy result set. */
  getPharmacyDetailsByIdentifier: Maybe<PharmacyInDetail>
  /** Returns a single pharmacy result set extended with No-Q result set. */
  getPharmacyInformationWithNoQData: Maybe<NoQPharmacyWithServices>
}

/** Pharmacies search */
export type QueryGetClosestPharmaciesArgs = {
  activeServiceGroupIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  activeServiceGroupIdsMatchAll: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  activeServiceTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  activeServiceTypeIdsMatchAll: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  channels?: InputMaybe<Array<InputMaybe<ChannelInput>>>
  groups: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  includeTestPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  location: InputMaybe<LocationInput>
  magazines: InputMaybe<Array<InputMaybe<Magazine>>>
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNowOrActiveEmergencyService?: InputMaybe<Scalars['Boolean']['input']>
  onlyVersorgerPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithMedicalAid?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pcases: InputMaybe<Array<InputMaybe<Classification>>>
  size?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
}

/** Pharmacies search */
export type QueryGetClosestPharmaciesBoostPostCodeArgs = {
  channels?: InputMaybe<Array<InputMaybe<ChannelInput>>>
  groups: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  includeTestPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  location: InputMaybe<LocationInput>
  magazines: InputMaybe<Array<InputMaybe<Magazine>>>
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNowOrActiveEmergencyService?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pcases: InputMaybe<Array<InputMaybe<Classification>>>
  postcode: Scalars['String']['input']
  size?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
}

/** Pharmacies search */
export type QueryGetClosestPharmaciesForNoQServiceArgs = {
  dateFrom: InputMaybe<Scalars['DateTime']['input']>
  dateTo: InputMaybe<Scalars['DateTime']['input']>
  groups: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  includeTestPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  location: InputMaybe<LocationInput>
  page?: InputMaybe<Scalars['Int']['input']>
  serviceName: InputMaybe<Scalars['String']['input']>
  serviceNames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  size?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
}

/** Pharmacies search */
export type QueryGetClosestPharmaciesWithPzNsArgs = {
  PZNs: Array<InputMaybe<Scalars['String']['input']>>
  channels?: InputMaybe<Array<InputMaybe<ChannelInput>>>
  groups: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  includeTestPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  location: InputMaybe<LocationInput>
  magazines: InputMaybe<Array<InputMaybe<Magazine>>>
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNowOrActiveEmergencyService?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pcases: InputMaybe<Array<InputMaybe<Classification>>>
  size?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
}

/** Pharmacies search */
export type QueryGetClosestPharmaciesWithPzNsBoostPostCodeArgs = {
  PZNs: Array<InputMaybe<Scalars['String']['input']>>
  channels?: InputMaybe<Array<InputMaybe<ChannelInput>>>
  groups: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  includeTestPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  location: InputMaybe<LocationInput>
  magazines: InputMaybe<Array<InputMaybe<Magazine>>>
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNow?: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNowOrActiveEmergencyService?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable?: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pcases: InputMaybe<Array<InputMaybe<Classification>>>
  postcode: Scalars['String']['input']
  size?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
}

/** Pharmacies search */
export type QueryGetPharmacyDetailByIdentifierListArgs = {
  pharmacyIdentifiers: InputMaybe<Array<Scalars['String']['input']>>
}

/** Pharmacies search */
export type QueryGetPharmacyDetailListArgs = {
  pharmacyIds: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Pharmacies search */
export type QueryGetPharmacyDetailsArgs = {
  apoDeId: InputMaybe<Scalars['Int']['input']>
  pharmacyId: InputMaybe<Scalars['Int']['input']>
}

/** Pharmacies search */
export type QueryGetPharmacyDetailsByIdentifierArgs = {
  pharmacyIdentifier: Scalars['String']['input']
}

/** Pharmacies search */
export type QueryGetPharmacyInformationWithNoQDataArgs = {
  dateFrom: InputMaybe<Scalars['DateTime']['input']>
  dateTo: InputMaybe<Scalars['DateTime']['input']>
  pharmacyId: Scalars['Int']['input']
}

export type RawEmergencyTimes = {
  __typename?: 'RawEmergencyTimes'
  currentlyActiveHours: Maybe<EmergencyHours>
  hoursStartingAtMidnight: Maybe<EmergencyHours>
  hoursStartingLaterToday: Maybe<EmergencyHours>
}

/** A service. */
export type Service = {
  __typename?: 'Service'
  /** List of service descriptions. */
  descriptions: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Should service be emphasized. */
  emphasized: Maybe<Scalars['Boolean']['output']>
  /** A service name. */
  name: Maybe<Scalars['String']['output']>
  /** A service title. */
  title: Maybe<Scalars['String']['output']>
}

/** Information about services available for booking on No-Q system. */
export type SocialLinks = {
  __typename?: 'SocialLinks'
  /** Address of the pharmacy facebook page. */
  facebook: Maybe<Scalars['String']['output']>
  /** Pharmacy Instagram handle. */
  instagram: Maybe<Scalars['String']['output']>
  /** Pharmacy LinkedIn page. */
  linkedIn: Maybe<Scalars['String']['output']>
  /** Pharmacy NebenanDe page. */
  nebenanDe: Maybe<Scalars['String']['output']>
  /** Pharmacy TikTok page. */
  tiktok: Maybe<Scalars['String']['output']>
  /** Pharmacy Twitter handle. */
  twitter: Maybe<Scalars['String']['output']>
  /** Pharmacy Xing page. */
  xing: Maybe<Scalars['String']['output']>
}

export type StandardDeliveryInformation = {
  __typename?: 'StandardDeliveryInformation'
  /** Custom text for the delivery service. */
  customText: Maybe<Scalars['String']['output']>
  /** Custom title for the delivery service. */
  customTitle: Maybe<Scalars['String']['output']>
  /** Delivery time can be arranged by agreement. */
  deliveryByAgreement: Maybe<Scalars['Boolean']['output']>
  /** Limitation of a delivery service. */
  deliveryLimits: Maybe<DeliveryLimits>
  /** The number of hours pharmacy needs to prepare shipment for delivery. */
  deliveryPeriod: Maybe<Scalars['Int']['output']>
  /** List of available delivery slots in a next couple of days. */
  deliveryTimes: Maybe<Array<Maybe<DeliveryTimes>>>
  /** Is the standard delivery service enabled. */
  enabled: Maybe<Scalars['Boolean']['output']>
  /** Does pharmacy offers free delivery service. */
  freeDelivery: Maybe<Scalars['Boolean']['output']>
  /**
   * If this is turned on, prescriptions have free delivery.
   * @deprecated Renamed to "prescriptionDeliveryFree"
   */
  freePrescriptionDelivery: Maybe<Scalars['Boolean']['output']>
  /** If this is turned on, only online payment is possible. */
  onlyOnlinePayment: Maybe<Scalars['Boolean']['output']>
  /** Text which should be displayed as an information when the medication can be picked up without the product context */
  pickupText: Maybe<Scalars['String']['output']>
  /** Does pharmacy offers delivery service for prescriptions. */
  prescriptionDelivery: Maybe<Scalars['Boolean']['output']>
  /** Does pharmacy offers delivery service for prescriptions. */
  prescriptionDeliveryCost: Maybe<Scalars['Float']['output']>
  /** If this is turned on, prescriptions have free delivery. */
  prescriptionDeliveryFree: Maybe<Scalars['Boolean']['output']>
  /** Prescriptions will always be able to have delivery if  this is turned on. */
  prescriptionDeliveryNoMinimum: Maybe<Scalars['Boolean']['output']>
  /** Pricing information for delivery service in case we have prescriptions. */
  prescriptionPrice: Maybe<DeliveryPrice>
  /** Pricing information for delivery service. */
  price: Maybe<DeliveryPrice>
}

/** Working hours day by day. If null day is off. */
export type WeeklyWorkingHours = {
  __typename?: 'WeeklyWorkingHours'
  /** Working hours for friday */
  fri: Maybe<DailyWorkingHours>
  /** Working hours for monday */
  mon: Maybe<DailyWorkingHours>
  /** Working hours for saturday */
  sat: Maybe<DailyWorkingHours>
  /** Working hours for sunday */
  sun: Maybe<DailyWorkingHours>
  /** Working hours for thursday */
  thu: Maybe<DailyWorkingHours>
  /** Working hours for tuesday */
  tue: Maybe<DailyWorkingHours>
  /** Working hours for wednsday */
  wed: Maybe<DailyWorkingHours>
}

/** A message that has been automatically generated and provides information about the hours of operation or working hours of a location during a single day, expressed in the German language. */
export type WorkingDay = {
  __typename?: 'WorkingDay'
  /** The name of a specific day, such as Monday or Tuesday, expressed in the German language. */
  day: Maybe<Scalars['String']['output']>
  /** Is this day a current day. */
  isToday: Maybe<Scalars['Boolean']['output']>
  /** Information about the hours of operation of a location, expressed in the German language. */
  text: Maybe<Scalars['String']['output']>
}

/** Start and end times */
export type WorkingHours = {
  __typename?: 'WorkingHours'
  /** Time of starts */
  from: Maybe<Scalars['String']['output']>
  /** Time of end */
  to: Maybe<Scalars['String']['output']>
}

export type DeliverySettingsQueryVariables = Exact<{
  pharmacyId: Scalars['Int']['input']
}>

export type DeliverySettingsQuery = { __typename?: 'Query'; getPharmacyDetails: { __typename?: 'PharmacyInDetail'; classifications: Array<Classification>; delivery: { __typename?: 'PharmacyDeliveryInformation'; standard: { __typename?: 'StandardDeliveryInformation'; deliveryByAgreement: boolean; deliveryPeriod: number; enabled: boolean; freeDelivery: boolean; prescriptionDelivery: boolean; prescriptionDeliveryFree: boolean; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; deliveryTimes: Array<{ __typename?: 'DeliveryTimes'; timeTo: string; timeFrom: string; day: string; slotIsToday: boolean; date: string; value: string }>; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number }; prescriptionPrice: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } }; express: { __typename?: 'ExpressDeliveryInformation'; deliveryTime: number; enabled: boolean; inventoryType: string; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } } } } }

export type SearchPharmacyInformationWithNoQDataQueryVariables = Exact<{
  pharmacyId: Scalars['Int']['input']
}>

export type SearchPharmacyInformationWithNoQDataQuery = { __typename?: 'Query'; getPharmacyInformationWithNoQData: { __typename?: 'NoQPharmacyWithServices'; name: string; active: boolean; city: string; classifications: Array<Classification>; noQ: { __typename?: 'NoQSinglePharmacyDetail'; noQSlug: string; noQServices: Array<{ __typename?: 'NoQService'; noqServiceSlug: string; noqServiceName: string; noqServiceFreeSpots: number; noqServiceUrl: string }> } } }

export type SearchClosestPharmaciesForNoQServiceQueryVariables = Exact<{
  location: LocationInput
  serviceNames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>
  size: InputMaybe<Scalars['Int']['input']>
  page: InputMaybe<Scalars['Int']['input']>
}>

export type SearchClosestPharmaciesForNoQServiceQuery = { __typename?: 'Query'; getClosestPharmaciesForNoQService: { __typename?: 'NoQPharmacyList'; pages: number; pharmacies: Array<{ __typename?: 'NoQPharmacy'; id: string; name: string; street: string; postcode: string; city: string; slug: string; classifications: Array<Classification>; magazines: Array<Magazine>; delivery: boolean; expressDelivery: boolean; distance: number; isOpenNow: boolean; isOnlinePaymentAvailable: boolean; location: { __typename?: 'GeoPoint'; lat: number; lon: number }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean }>; workingDays: Array<{ __typename?: 'WorkingDay'; day: string; text: string; isToday: boolean }>; openingTimesMessages: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } }; noQ: { __typename?: 'NoQ'; noQFreeSpots: number; noQSlots: number; noQSlug: string; noQUrl: string } }> } }

export type SearchClosestPharmaciesQueryVariables = Exact<{
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  location: LocationInput
  size: InputMaybe<Scalars['Int']['input']>
  page: InputMaybe<Scalars['Int']['input']>
  magazines: InputMaybe<Array<InputMaybe<Magazine>> | InputMaybe<Magazine>>
  channels: InputMaybe<Array<InputMaybe<ChannelInput>> | InputMaybe<ChannelInput>>
  pcases: InputMaybe<Array<InputMaybe<Classification>> | InputMaybe<Classification>>
  onlyOpenNow: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow: InputMaybe<Scalars['Boolean']['input']>
  onlyOpenNowOrActiveEmergencyService: InputMaybe<Scalars['Boolean']['input']>
  activeServiceGroupIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>
  activeServiceTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>
  onlyWithMedicalAid: InputMaybe<Scalars['Boolean']['input']>
  onlyVersorgerPharmacies: InputMaybe<Scalars['Boolean']['input']>
  includeTestPharmacies: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchClosestPharmaciesQuery = { __typename?: 'Query'; getClosestPharmacies: { __typename?: 'PharmacyList'; pages: number; pharmacies: Array<{ __typename?: 'Pharmacy'; id: string; name: string; pharmacyAdditionalName: string; street: string; postcode: string; city: string; slug: string; classifications: Array<Classification>; magazines: Array<Magazine>; delivery: boolean; expressDelivery: boolean; distance: number; isOpenNow: boolean; isOnlinePaymentAvailable: boolean; isEmergencyServiceOffered: boolean; isEmergencyServiceOpen: boolean; activeServiceGroupIds: Array<number>; activeServiceTypeIds: Array<number>; isVersorgerPharmacy: boolean; appointmentServices: { __typename?: 'AppointmentServices'; allowsDiagnostics: boolean; allowsDisplayToCustomers: boolean; allowsLaboratoryTests: boolean; allowsMedicalAid: boolean; allowsOwnPdl: boolean; allowsPdl: boolean; allowsVaccination: boolean }; availableSlots: Array<{ __typename?: 'AvailableSlot'; serviceTypeId: number; serviceTypeName: string; availableCount: number; lookaheadHours: number; nextAvailableAt: string }>; emergencyTimesMessages: { __typename?: 'EmergencyTimesMessage'; large: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string } }; location: { __typename?: 'GeoPoint'; lat: number; lon: number }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean }>; workingDays: Array<{ __typename?: 'WorkingDay'; day: string; text: string; isToday: boolean }>; openingTimesMessages: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } } }> } }

export type SearchClosestPharmaciesBoostPostCodeQueryVariables = Exact<{
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  location: LocationInput
  postcode: Scalars['String']['input']
  size: InputMaybe<Scalars['Int']['input']>
  page: InputMaybe<Scalars['Int']['input']>
  magazines: InputMaybe<Array<InputMaybe<Magazine>> | InputMaybe<Magazine>>
  channels: InputMaybe<Array<InputMaybe<ChannelInput>> | InputMaybe<ChannelInput>>
  pcases: InputMaybe<Array<InputMaybe<Classification>> | InputMaybe<Classification>>
  onlyOpenNow: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchClosestPharmaciesBoostPostCodeQuery = { __typename?: 'Query'; getClosestPharmaciesBoostPostCode: { __typename?: 'PharmacyList'; pages: number; pharmacies: Array<{ __typename?: 'Pharmacy'; id: string; name: string; street: string; postcode: string; city: string; slug: string; classifications: Array<Classification>; magazines: Array<Magazine>; delivery: boolean; expressDelivery: boolean; distance: number; isOpenNow: boolean; isOnlinePaymentAvailable: boolean; isEmergencyServiceOffered: boolean; isEmergencyServiceOpen: boolean; emergencyTimesMessages: { __typename?: 'EmergencyTimesMessage'; large: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string } }; location: { __typename?: 'GeoPoint'; lat: number; lon: number }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean }>; workingDays: Array<{ __typename?: 'WorkingDay'; day: string; text: string; isToday: boolean }>; openingTimesMessages: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } } }> } }

export type SearchClosestPharmaciesWithPzNsQueryVariables = Exact<{
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  location: LocationInput
  PZNs: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  size: InputMaybe<Scalars['Int']['input']>
  page: InputMaybe<Scalars['Int']['input']>
  magazines: InputMaybe<Array<InputMaybe<Magazine>> | InputMaybe<Magazine>>
  channels: InputMaybe<Array<InputMaybe<ChannelInput>> | InputMaybe<ChannelInput>>
  pcases: InputMaybe<Array<InputMaybe<Classification>> | InputMaybe<Classification>>
  onlyOpenNow: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchClosestPharmaciesWithPzNsQuery = { __typename?: 'Query'; getClosestPharmaciesWithPZNs: { __typename?: 'PharmacyList'; pages: number; pharmacies: Array<{ __typename?: 'Pharmacy'; id: string; name: string; street: string; postcode: string; city: string; slug: string; classifications: Array<Classification>; magazines: Array<Magazine>; delivery: boolean; expressDelivery: boolean; distance: number; isOpenNow: boolean; isOnlinePaymentAvailable: boolean; isEmergencyServiceOffered: boolean; isEmergencyServiceOpen: boolean; isVersorgerPharmacy: boolean; emergencyTimesMessages: { __typename?: 'EmergencyTimesMessage'; large: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string } }; location: { __typename?: 'GeoPoint'; lat: number; lon: number }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean }>; workingDays: Array<{ __typename?: 'WorkingDay'; day: string; text: string; isToday: boolean }>; openingTimesMessages: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } } }> } }

export type SearchClosestPharmaciesWithPzNsBoostPostCodeQueryVariables = Exact<{
  onlyActive: InputMaybe<Scalars['Boolean']['input']>
  location: LocationInput
  postcode: Scalars['String']['input']
  PZNs: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  size: InputMaybe<Scalars['Int']['input']>
  page: InputMaybe<Scalars['Int']['input']>
  magazines: InputMaybe<Array<InputMaybe<Magazine>> | InputMaybe<Magazine>>
  channels: InputMaybe<Array<InputMaybe<ChannelInput>> | InputMaybe<ChannelInput>>
  pcases: InputMaybe<Array<InputMaybe<Classification>> | InputMaybe<Classification>>
  onlyOpenNow: InputMaybe<Scalars['Boolean']['input']>
  onlyWithOnlinePaymentAvailable: InputMaybe<Scalars['Boolean']['input']>
  onlyWithRegularOrExpressDelivery: InputMaybe<Scalars['Boolean']['input']>
  onlyEmergencyServiceOfferedNow: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchClosestPharmaciesWithPzNsBoostPostCodeQuery = { __typename?: 'Query'; getClosestPharmaciesWithPZNsBoostPostCode: { __typename?: 'PharmacyList'; pages: number; pharmacies: Array<{ __typename?: 'Pharmacy'; id: string; name: string; street: string; postcode: string; city: string; slug: string; classifications: Array<Classification>; magazines: Array<Magazine>; delivery: boolean; expressDelivery: boolean; distance: number; isOpenNow: boolean; isOnlinePaymentAvailable: boolean; isEmergencyServiceOffered: boolean; isEmergencyServiceOpen: boolean; isVersorgerPharmacy: boolean; emergencyTimesMessages: { __typename?: 'EmergencyTimesMessage'; large: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string } }; location: { __typename?: 'GeoPoint'; lat: number; lon: number }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean }>; workingDays: Array<{ __typename?: 'WorkingDay'; day: string; text: string; isToday: boolean }>; openingTimesMessages: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } } }> } }

export type DeliveryAndPaymentSettingsQueryVariables = Exact<{
  pharmacyId: Scalars['Int']['input']
}>

export type DeliveryAndPaymentSettingsQuery = { __typename?: 'Query'; getPharmacyDetails: { __typename?: 'PharmacyInDetail'; classifications: Array<Classification>; delivery: { __typename?: 'PharmacyDeliveryInformation'; standard: { __typename?: 'StandardDeliveryInformation'; deliveryByAgreement: boolean; deliveryPeriod: number; enabled: boolean; freeDelivery: boolean; prescriptionDelivery: boolean; prescriptionDeliveryFree: boolean; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; deliveryTimes: Array<{ __typename?: 'DeliveryTimes'; timeTo: string; timeFrom: string; day: string; slotIsToday: boolean; date: string; value: string }>; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number }; prescriptionPrice: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } }; express: { __typename?: 'ExpressDeliveryInformation'; deliveryTime: number; enabled: boolean; inventoryType: string; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } } } } }

export type PharmacyDetailsQueryVariables = Exact<{
  pharmacyId: Scalars['Int']['input']
}>

export type PharmacyDetailsQuery = { __typename?: 'Query'; getPharmacyDetails: { __typename?: 'PharmacyInDetail'; classifications: Array<Classification>; id: string; magazines: Array<Magazine>; isEmergencyServiceOpen: boolean; pharmacyAdditionalName: string; additionalInformation: { __typename?: 'PharmacyAdditionalInformation'; apodeId: number; logo: string; name: string; slug: string; url: string; allowsPayments: boolean; isTestPharmacy: boolean }; delivery: { __typename?: 'PharmacyDeliveryInformation'; standard: { __typename?: 'StandardDeliveryInformation'; customTitle: string; customText: string; deliveryByAgreement: boolean; deliveryPeriod: number; enabled: boolean; freeDelivery: boolean; prescriptionDelivery: boolean; prescriptionDeliveryFree: boolean; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; deliveryTimes: Array<{ __typename?: 'DeliveryTimes'; timeTo: string; timeFrom: string; day: string; slotIsToday: boolean; date: string; value: string }>; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number }; prescriptionPrice: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } }; express: { __typename?: 'ExpressDeliveryInformation'; deliveryTime: number; enabled: boolean; inventoryType: string; deliveryLimits: { __typename?: 'DeliveryLimits'; zipCodes: Array<string>; airDistance: number; streetDistance: number }; price: { __typename?: 'DeliveryPrice'; cost: number; freeDeliveryMinimum: number; deliveryMinimum: number } } }; businessHours: { __typename?: 'PharmacyBusinessHours'; isOpenNow: boolean; isOpenToday: boolean; days: Array<{ __typename?: 'PharmacyWorkingDays'; day: string; isToday: boolean; text: string }>; status: { __typename?: 'OpeningTimesMessage'; large: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'OpeningTimesScreenMessage'; label: string; text: string } } }; channels: Array<{ __typename?: 'Channel'; id: number; linkToProfile: boolean; name: string; type: string }>; company: { __typename?: 'PharmacyCompanyInformation'; legalEntity: string; name: string; owners: Array<{ __typename?: 'PharmacyCompanyOwner'; name: string; title: string }> }; contact: { __typename?: 'PharmacyContactInformation'; email: string; fax: string; phone: string; whatsAppMobilePhoneNumber: string; websiteUrl: string; socialLinks: { __typename?: 'SocialLinks'; facebook: string; instagram: string; linkedIn: string; nebenanDe: string; tiktok: string; twitter: string; xing: string } }; location: { __typename?: 'PharmacyLocationInformation'; city: string; postcode: string; region: string; street: string; geo: { __typename?: 'GeoPoint'; lat: number; lon: number } }; services: Array<{ __typename?: 'Service'; descriptions: Array<string>; emphasized: boolean; name: string; title: string }>; emergencyTimesMessages: { __typename?: 'EmergencyTimesMessage'; large: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; medium: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string }; small: { __typename?: 'EmergencyTimesScreenMessage'; label: string; text: string } } } }

export type VaccineBookingAppointmentsQueryVariables = Exact<{
  pharmacyId: Scalars['Int']['input']
}>

export type VaccineBookingAppointmentsQuery = { __typename?: 'Query'; getPharmacyInformationWithNoQData: { __typename?: 'NoQPharmacyWithServices'; id: string; noQ: { __typename?: 'NoQSinglePharmacyDetail'; noQSlug: string; noQServices: Array<{ __typename?: 'NoQService'; noqServiceName: string; noqServiceUrl: string }> } } }

export const DeliverySettings = gql`
    query DeliverySettings($pharmacyId: Int!) {
  getPharmacyDetails(pharmacyId: $pharmacyId) {
    classifications
    delivery {
      standard {
        deliveryByAgreement
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryPeriod
        deliveryTimes {
          timeTo
          timeFrom
          day
          slotIsToday
          date
          value
        }
        enabled
        freeDelivery
        prescriptionDelivery
        prescriptionDeliveryFree
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
        prescriptionPrice {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
      express {
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryTime
        enabled
        inventoryType
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
    }
  }
}
    `
export const SearchPharmacyInformationWithNoQData = gql`
    query searchPharmacyInformationWithNoQData($pharmacyId: Int!) {
  getPharmacyInformationWithNoQData(pharmacyId: $pharmacyId) {
    name
    active
    city
    classifications
    noQ {
      noQServices {
        noqServiceSlug
        noqServiceName
        noqServiceFreeSpots
        noqServiceUrl
      }
      noQSlug
    }
  }
}
    `
export const SearchClosestPharmaciesForNoQService = gql`
    query searchClosestPharmaciesForNoQService($location: LocationInput!, $serviceNames: [String], $size: Int, $page: Int) {
  getClosestPharmaciesForNoQService(
    location: $location
    serviceNames: $serviceNames
    size: $size
    page: $page
  ) {
    pharmacies {
      id
      name
      street
      postcode
      city
      slug
      classifications
      magazines
      delivery
      expressDelivery
      distance
      isOpenNow
      isOnlinePaymentAvailable
      location {
        lat
        lon
      }
      channels {
        id
        linkToProfile
      }
      workingDays {
        day
        text
        isToday
      }
      openingTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
      noQ {
        noQFreeSpots
        noQSlots
        noQSlug
        noQUrl
      }
    }
    pages
  }
}
    `
export const SearchClosestPharmacies = gql`
    query searchClosestPharmacies($onlyActive: Boolean, $location: LocationInput!, $size: Int, $page: Int, $magazines: [Magazine], $channels: [ChannelInput], $pcases: [Classification], $onlyOpenNow: Boolean, $onlyWithOnlinePaymentAvailable: Boolean, $onlyWithRegularOrExpressDelivery: Boolean, $onlyEmergencyServiceOfferedNow: Boolean, $onlyOpenNowOrActiveEmergencyService: Boolean, $activeServiceGroupIds: [Int], $activeServiceTypeIds: [Int], $onlyWithMedicalAid: Boolean, $onlyVersorgerPharmacies: Boolean, $includeTestPharmacies: Boolean) {
  getClosestPharmacies(
    location: $location
    onlyActive: $onlyActive
    size: $size
    page: $page
    magazines: $magazines
    channels: $channels
    pcases: $pcases
    onlyOpenNow: $onlyOpenNow
    onlyWithOnlinePaymentAvailable: $onlyWithOnlinePaymentAvailable
    onlyWithRegularOrExpressDelivery: $onlyWithRegularOrExpressDelivery
    onlyEmergencyServiceOfferedNow: $onlyEmergencyServiceOfferedNow
    onlyOpenNowOrActiveEmergencyService: $onlyOpenNowOrActiveEmergencyService
    activeServiceGroupIds: $activeServiceGroupIds
    activeServiceTypeIds: $activeServiceTypeIds
    onlyWithMedicalAid: $onlyWithMedicalAid
    onlyVersorgerPharmacies: $onlyVersorgerPharmacies
    includeTestPharmacies: $includeTestPharmacies
  ) {
    pharmacies {
      id
      name
      pharmacyAdditionalName
      street
      postcode
      city
      slug
      classifications
      magazines
      delivery
      expressDelivery
      distance
      isOpenNow
      isOnlinePaymentAvailable
      isEmergencyServiceOffered
      isEmergencyServiceOpen
      activeServiceGroupIds
      activeServiceTypeIds
      isVersorgerPharmacy
      appointmentServices {
        allowsDiagnostics
        allowsDisplayToCustomers
        allowsLaboratoryTests
        allowsMedicalAid
        allowsOwnPdl
        allowsPdl
        allowsVaccination
      }
      availableSlots {
        serviceTypeId
        serviceTypeName
        availableCount
        lookaheadHours
        nextAvailableAt
      }
      emergencyTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
      location {
        lat
        lon
      }
      channels {
        id
        linkToProfile
      }
      workingDays {
        day
        text
        isToday
      }
      openingTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
    }
    pages
  }
}
    `
export const SearchClosestPharmaciesBoostPostCode = gql`
    query searchClosestPharmaciesBoostPostCode($onlyActive: Boolean, $location: LocationInput!, $postcode: String!, $size: Int, $page: Int, $magazines: [Magazine], $channels: [ChannelInput], $pcases: [Classification], $onlyOpenNow: Boolean, $onlyWithOnlinePaymentAvailable: Boolean, $onlyWithRegularOrExpressDelivery: Boolean, $onlyEmergencyServiceOfferedNow: Boolean) {
  getClosestPharmaciesBoostPostCode(
    location: $location
    postcode: $postcode
    onlyActive: $onlyActive
    size: $size
    page: $page
    magazines: $magazines
    channels: $channels
    pcases: $pcases
    onlyOpenNow: $onlyOpenNow
    onlyWithOnlinePaymentAvailable: $onlyWithOnlinePaymentAvailable
    onlyWithRegularOrExpressDelivery: $onlyWithRegularOrExpressDelivery
    onlyEmergencyServiceOfferedNow: $onlyEmergencyServiceOfferedNow
  ) {
    pharmacies {
      id
      name
      street
      postcode
      city
      slug
      classifications
      magazines
      delivery
      expressDelivery
      distance
      isOpenNow
      isOnlinePaymentAvailable
      isEmergencyServiceOffered
      isEmergencyServiceOpen
      emergencyTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
      location {
        lat
        lon
      }
      channels {
        id
        linkToProfile
      }
      workingDays {
        day
        text
        isToday
      }
      openingTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
    }
    pages
  }
}
    `
export const SearchClosestPharmaciesWithPzNs = gql`
    query searchClosestPharmaciesWithPZNs($onlyActive: Boolean, $location: LocationInput!, $PZNs: [String]!, $size: Int, $page: Int, $magazines: [Magazine], $channels: [ChannelInput], $pcases: [Classification], $onlyOpenNow: Boolean, $onlyWithOnlinePaymentAvailable: Boolean, $onlyWithRegularOrExpressDelivery: Boolean, $onlyEmergencyServiceOfferedNow: Boolean) {
  getClosestPharmaciesWithPZNs(
    location: $location
    PZNs: $PZNs
    onlyActive: $onlyActive
    size: $size
    page: $page
    magazines: $magazines
    channels: $channels
    pcases: $pcases
    onlyOpenNow: $onlyOpenNow
    onlyWithOnlinePaymentAvailable: $onlyWithOnlinePaymentAvailable
    onlyWithRegularOrExpressDelivery: $onlyWithRegularOrExpressDelivery
    onlyEmergencyServiceOfferedNow: $onlyEmergencyServiceOfferedNow
  ) {
    pharmacies {
      id
      name
      street
      postcode
      city
      slug
      classifications
      magazines
      delivery
      expressDelivery
      distance
      isOpenNow
      isOnlinePaymentAvailable
      isEmergencyServiceOffered
      isEmergencyServiceOpen
      isVersorgerPharmacy
      emergencyTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
      location {
        lat
        lon
      }
      channels {
        id
        linkToProfile
      }
      workingDays {
        day
        text
        isToday
      }
      openingTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
    }
    pages
  }
}
    `
export const SearchClosestPharmaciesWithPzNsBoostPostCode = gql`
    query searchClosestPharmaciesWithPZNsBoostPostCode($onlyActive: Boolean, $location: LocationInput!, $postcode: String!, $PZNs: [String]!, $size: Int, $page: Int, $magazines: [Magazine], $channels: [ChannelInput], $pcases: [Classification], $onlyOpenNow: Boolean, $onlyWithOnlinePaymentAvailable: Boolean, $onlyWithRegularOrExpressDelivery: Boolean, $onlyEmergencyServiceOfferedNow: Boolean) {
  getClosestPharmaciesWithPZNsBoostPostCode(
    location: $location
    postcode: $postcode
    PZNs: $PZNs
    onlyActive: $onlyActive
    size: $size
    page: $page
    magazines: $magazines
    channels: $channels
    pcases: $pcases
    onlyOpenNow: $onlyOpenNow
    onlyWithOnlinePaymentAvailable: $onlyWithOnlinePaymentAvailable
    onlyWithRegularOrExpressDelivery: $onlyWithRegularOrExpressDelivery
    onlyEmergencyServiceOfferedNow: $onlyEmergencyServiceOfferedNow
  ) {
    pharmacies {
      id
      name
      street
      postcode
      city
      slug
      classifications
      magazines
      delivery
      expressDelivery
      distance
      isOpenNow
      isOnlinePaymentAvailable
      isEmergencyServiceOffered
      isEmergencyServiceOpen
      isVersorgerPharmacy
      emergencyTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
      location {
        lat
        lon
      }
      channels {
        id
        linkToProfile
      }
      workingDays {
        day
        text
        isToday
      }
      openingTimesMessages {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
    }
    pages
  }
}
    `
export const DeliveryAndPaymentSettings = gql`
    query DeliveryAndPaymentSettings($pharmacyId: Int!) {
  getPharmacyDetails(pharmacyId: $pharmacyId) {
    classifications
    delivery {
      standard {
        deliveryByAgreement
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryPeriod
        deliveryTimes {
          timeTo
          timeFrom
          day
          slotIsToday
          date
          value
        }
        enabled
        freeDelivery
        prescriptionDelivery
        prescriptionDeliveryFree
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
        prescriptionPrice {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
      express {
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryTime
        enabled
        inventoryType
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
    }
  }
}
    `
export const PharmacyDetails = gql`
    query PharmacyDetails($pharmacyId: Int!) {
  getPharmacyDetails(pharmacyId: $pharmacyId) {
    additionalInformation {
      apodeId
      logo
      name
      slug
      url
      allowsPayments
      isTestPharmacy
    }
    delivery {
      standard {
        customTitle
        customText
        deliveryByAgreement
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryPeriod
        deliveryTimes {
          timeTo
          timeFrom
          day
          slotIsToday
          date
          value
        }
        enabled
        freeDelivery
        prescriptionDelivery
        prescriptionDeliveryFree
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
        prescriptionPrice {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
      express {
        deliveryLimits {
          zipCodes
          airDistance
          streetDistance
        }
        deliveryTime
        enabled
        inventoryType
        price {
          cost
          freeDeliveryMinimum
          deliveryMinimum
        }
      }
    }
    businessHours {
      days {
        day
        isToday
        text
      }
      isOpenNow
      isOpenToday
      status {
        large {
          label
          text
        }
        medium {
          label
          text
        }
        small {
          label
          text
        }
      }
    }
    channels {
      id
      linkToProfile
      name
      type
    }
    classifications
    company {
      legalEntity
      name
      owners {
        name
        title
      }
    }
    contact {
      email
      fax
      phone
      whatsAppMobilePhoneNumber
      socialLinks {
        facebook
        instagram
        linkedIn
        nebenanDe
        tiktok
        twitter
        xing
      }
      websiteUrl
      whatsAppMobilePhoneNumber
    }
    id
    location {
      city
      geo {
        lat
        lon
      }
      postcode
      region
      street
    }
    magazines
    services {
      descriptions
      emphasized
      name
      title
    }
    isEmergencyServiceOpen
    emergencyTimesMessages {
      large {
        label
        text
      }
      medium {
        label
        text
      }
      small {
        label
        text
      }
    }
    pharmacyAdditionalName
  }
}
    `
export const VaccineBookingAppointments = gql`
    query VaccineBookingAppointments($pharmacyId: Int!) {
  getPharmacyInformationWithNoQData(pharmacyId: $pharmacyId) {
    id
    noQ {
      noQSlug
      noQServices {
        noqServiceName
        noqServiceName
        noqServiceUrl
      }
    }
  }
}
    `
